/**
 * Quiet Luxury — Complete the Look (CTL-A).
 * Upgrades cart drawer picks via Shopify recommendations (complementary → related),
 * then best-seller JSON fallback. Ajax add refreshes the drawer.
 */
(function () {
  'use strict';

  var MAX_DEFAULT = 2;

  function moneyEu(cents) {
    var n = Math.round(Number(cents) / 100);
    if (isNaN(n)) return '';
    return String(n) + '\u00a0€';
  }

  function blockedProduct(p) {
    var hay = ((p.handle || '') + ' ' + (p.title || '')).toLowerCase();
    if (hay.indexOf('windbreaker') !== -1 || hay.indexOf('wind-breaker') !== -1) return true;
    var tags = p.tags || [];
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i]).toLowerCase();
      if (t === 'tier-atelierspace' || t === 'windbreaker') return true;
    }
    return false;
  }

  function firstAvailableVariant(p) {
    if (p.variants && p.variants.length) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v && v.available !== false) return v;
      }
      return p.variants[0];
    }
    if (p.variant_id) {
      return { id: p.variant_id, price: p.price, available: true };
    }
    return null;
  }

  function needsSize(p) {
    if (p.needs_size === true) return true;
    if (p.needs_size === false) return false;
    var variants = p.variants || [];
    if (variants.length <= 1) return false;
    var options = p.options || [];
    for (var i = 0; i < options.length; i++) {
      if (String(options[i]).toLowerCase().indexOf('size') !== -1) return true;
    }
    return variants.length > 1;
  }

  function sameFamily(cartBlob, p) {
    var hay = ((p.handle || '') + ' ' + (p.title || '') + ' ' + (p.type || '')).toLowerCase();
    var blob = String(cartBlob || '').toLowerCase();
    if (!blob) return false;
    var cartOuter =
      blob.indexOf('jacket') !== -1 ||
      blob.indexOf('gilet') !== -1 ||
      blob.indexOf('hooded') !== -1 ||
      blob.indexOf('outerwear') !== -1;
    var prodOuter =
      hay.indexOf('jacket') !== -1 ||
      hay.indexOf('gilet') !== -1 ||
      hay.indexOf('hooded') !== -1 ||
      hay.indexOf('outerwear') !== -1;
    if (cartOuter && prodOuter) return true;
    return false;
  }

  function normalizeRec(p) {
    var v = firstAvailableVariant(p);
    if (!v || v.available === false) return null;
    if (blockedProduct(p)) return null;
    var img = null;
    if (p.featured_image) {
      img = typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || null;
    } else if (p.images && p.images[0]) {
      img = typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || null;
    } else if (p.image) {
      img = p.image;
    }
    if (img && img.indexOf('width=') === -1) {
      img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=240';
    }
    return {
      id: p.id,
      variant_id: v.id,
      title: p.title,
      url: p.url || ('/products/' + (p.handle || '')),
      price: v.price != null ? v.price : p.price,
      image: img,
      needs_size: needsSize(p),
      type: p.type || '',
      handle: p.handle || '',
    };
  }

  function pickList(recProducts, fallback, cartIds, max, cartBlob) {
    var out = [];
    var seen = Object.assign({}, cartIds);

    function pushNorm(n, allowSameFamily) {
      if (!n || !n.variant_id) return;
      if (seen[String(n.id)]) return;
      if (!allowSameFamily && sameFamily(cartBlob, n)) return;
      seen[String(n.id)] = true;
      out.push(n);
    }

    recProducts.forEach(function (p) {
      if (out.length >= max) return;
      pushNorm(normalizeRec(p), false);
    });

    fallback.forEach(function (p) {
      if (out.length >= max) return;
      pushNorm(p, false);
    });

    /* last resort: allow same family if still empty */
    if (out.length < max) {
      recProducts.forEach(function (p) {
        if (out.length >= max) return;
        pushNorm(normalizeRec(p), true);
      });
      fallback.forEach(function (p) {
        if (out.length >= max) return;
        pushNorm(p, true);
      });
    }

    return out;
  }

  function renderList(root, items) {
    var list = root.querySelector('[data-ql-look-list]');
    if (!list) return;
    if (!items.length) {
      root.hidden = true;
      root.setAttribute('data-look-count', '0');
      return;
    }
    root.hidden = false;
    root.setAttribute('data-look-count', String(items.length));
    list.innerHTML = items
      .map(function (p) {
        var img = p.image
          ? '<img src="' +
            escapeAttr(p.image) +
            '" alt="" width="72" height="96" loading="lazy" decoding="async">'
          : '';
        var action = p.needs_size
          ? '<a class="ql-cart-look__add" href="' + escapeAttr(p.url) + '">SIZE</a>'
          : '<button type="button" class="ql-cart-look__add" data-ql-look-add data-variant-id="' +
            escapeAttr(String(p.variant_id)) +
            '" aria-label="Add ' +
            escapeAttr(p.title) +
            '">+ ADD</button>';
        return (
          '<li class="ql-cart-look__item">' +
          '<a class="ql-cart-look__media" href="' +
          escapeAttr(p.url) +
          '" tabindex="-1" aria-hidden="true">' +
          img +
          '</a>' +
          '<div class="ql-cart-look__meta">' +
          '<a class="ql-cart-look__title" href="' +
          escapeAttr(p.url) +
          '">' +
          escapeHtml(p.title) +
          '</a>' +
          '<span class="ql-cart-look__price">' +
          moneyEu(p.price) +
          '</span>' +
          '</div>' +
          action +
          '</li>'
        );
      })
      .join('');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function parseFallback(root) {
    var el = root.querySelector('[data-ql-look-fallback]');
    if (!el) return [];
    try {
      var raw = JSON.parse(el.textContent || '[]');
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function cartIdSet(root) {
    var raw = (root.getAttribute('data-cart-ids') || '').split(',');
    var set = {};
    raw.forEach(function (id) {
      if (id) set[String(id)] = true;
    });
    return set;
  }

  function fetchIntent(base, productId, intent, limit) {
    var endpoint = base || '/recommendations/products';
    if (endpoint.indexOf('.json') === -1) {
      endpoint = endpoint.replace(/\/?$/, '') + '.json';
    }
    var url =
      endpoint +
      (endpoint.indexOf('?') === -1 ? '?' : '&') +
      'product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      limit +
      '&intent=' +
      encodeURIComponent(intent);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) return [];
        return r.json();
      })
      .then(function (data) {
        return (data && data.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function upgradeRoot(root) {
    if (!root || root.getAttribute('data-ql-look-ready') === '1') return;
    root.setAttribute('data-ql-look-ready', '1');

    var productId = root.getAttribute('data-product-id');
    var base = root.getAttribute('data-rec-base') || '/recommendations/products';
    var max = parseInt(root.getAttribute('data-look-max') || String(MAX_DEFAULT), 10) || MAX_DEFAULT;
    var cartIds = cartIdSet(root);
    var cartBlob = root.getAttribute('data-cart-blob') || '';
    var fallback = parseFallback(root);

    if (!productId) {
      renderList(root, pickList([], fallback, cartIds, max, cartBlob));
      return;
    }

    fetchIntent(base, productId, 'complementary', 10).then(function (comp) {
      var chain = comp && comp.length ? Promise.resolve(comp) : fetchIntent(base, productId, 'related', 10);
      return chain.then(function (recs) {
        var items = pickList(recs || [], fallback, cartIds, max, cartBlob);
        renderList(root, items);
      });
    });
  }

  function scan(scope) {
    (scope || document)
      .querySelectorAll('[data-ql-complete-look]:not([data-ql-look-ready="1"])')
      .forEach(upgradeRoot);
  }

  function addVariant(btn) {
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    btn.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var body = {
      items: [{ id: parseInt(id, 10), quantity: 1 }],
    };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status || data.message || data.description || !data.sections) {
          console.warn('[ql-complete-look] add failed', data);
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ql-complete-look',
            cartData: data,
          });
        }
        window.setTimeout(function () {
          scan(drawer || document);
        }, 50);
      })
      .catch(function (err) {
        console.warn('[ql-complete-look] add error', err);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ql-look-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function () {
      scan(drawer);
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      window.setTimeout(function () {
        scan(document.querySelector('cart-drawer') || document);
      }, 80);
    });
  }
})();
